import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {
  // arrayOf, number, bool,
  func, object, string
} from 'prop-types';

import Aux from '../../components/Hoc/Aux';
import Intro from '../../components/Questions/Intro.jsx';

import {quizPaths, defaultQuizState} from '../../helpers/quiz';
import * as GeneralHelpers from '../../helpers/general';
import * as RouteHelpers from '../../helpers/routes';
import * as A from '../../redux/actions';

const mapStateToProps = state => {
  return {
    routing: state.routing
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectFamilyType: (familyType, isOriginal) => {
      dispatch(A.selectFamilyType(familyType, isOriginal));
    },
    updateAge: (age) => {
      dispatch(A.updateAge(age));
    },
    selectMedicare: (medicareYN) => {
      dispatch(A.selectMedicare(medicareYN));
    },
    selectBudget: (budget) => {
      dispatch(A.selectBudget(budget));
    },
    selectTravel: (travel) => {
      dispatch(A.selectTravel(travel));
    },
    updateHouseholdSize: (householdSize) => {
      dispatch(A.updateHouseholdSize(householdSize));
    },
    updateKidsCount: (kidsCount) => {
      dispatch(A.updateKidsCount(kidsCount));
    },
    updateIncome: (income) => {
      dispatch(A.updateIncome(income));
    },
    updateFullTimeEmployees: (numOfEmployees) => {
      dispatch(A.updateFullTimeEmployees(numOfEmployees));
    },
    selectEmployeeBudget: (employeeBudget) => {
      dispatch(A.selectEmployeeBudget(employeeBudget));
    },
    selectEmployeePref: (employeePref) => {
      dispatch(A.selectEmployeePref(employeePref));
    },
    updateQuote: (quote) => {
      dispatch(A.updateQuote(quote));
    },
    startOver: (restartQuiz) => {
      dispatch(A.startOver(restartQuiz));
    },
    setFieldValue: (fieldKey, fieldValue) => {
      dispatch(A.setFieldValue(fieldKey, fieldValue));
    }
  };
};

class Quiz extends Component {
  constructor (props) {
    super(props);

    this.isNextStep = this.isNextStepEnabled.bind(this);
    this.isPrevStep = this.isPrevStepEnabled.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.updateStep = this.updateStep.bind(this);
    this.setStep = this.props.setStep.bind(this);
  }

  state = {
    quiz: {}
  };

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {quiz, route, subroute} = p;
    const fapPathIdx = RouteHelpers.getPathIndexFromUrl('find-a-plan');
    const stepPathIdx = fapPathIdx ? (fapPathIdx + 1) : 0;
    const nextStepVal = fapPathIdx ? RouteHelpers.getPathValFromIndex(stepPathIdx) : 1;
    const skipStep = window.location.search.indexOf('skip=true') > -1;
    let fieldValues;
    let stepNum = 1;
    let expectedStep;
    let stepName;

    if (quiz.step) stepNum = quiz.step;

    if (stepNum === parseFloat(stepNum)) {
      if (nextStepVal !== stepNum && !_.isUndefined(nextStepVal) && nextStepVal !== '') {
        stepName = nextStepVal;
        if (stepNum < 2 && skipStep) {
          stepNum = RouteHelpers.getStepNumberFromRouteAndId(route, stepName);
        }
      } else stepName = RouteHelpers.getStepNameFromNum(stepNum);
    } else {
      stepName = stepNum;
      stepNum = RouteHelpers.getStepNumberFromRouteAndId(route, stepName);
    }

    if (!skipStep) {
      if (stepNum < 2) stepName = 'start';
      else {
        expectedStep = RouteHelpers.getStepNumberFromRouteAndId(route, stepName);
        if (expectedStep < stepNum) { // user pressed the back button
          stepNum = expectedStep;
          if (stepNum < 1) stepNum = 1;
          p.setStep(stepNum);
        }
      }
    }

    if (nextStepVal !== 'start' && nextStepVal !== stepName && route !== 'home' && !skipStep) {
      if (nextStepVal === '' || (!GeneralHelpers.getObjectDiff(
        defaultQuizState.fieldValues, p.quiz.fieldValues
      ).length && window.location.search.indexOf('skip=true') === -1)) {
        window.localStorage.setItem('lastStep', stepNum);
        RouteHelpers.history.push(RouteHelpers.newStepIndexForUrl(stepNum));
      } else props.setStep(nextStepVal);
    }

    if (quiz.fieldValues.FamilyType !== 'ChildrenOnly' && (
      route === 'child-health-plus')) { // this is always selected for CHP quotes:
      p.selectFamilyType('ChildrenOnly');
    }

    if (parseFloat(stepNum) < 2 || quiz.step === 'start') {
      // p.setFieldValue('QuizRoute', p.route);
      fieldValues = quiz.fieldValues;

      switch (route) {
        case 'individuals':
          if (fieldValues.FamilyType === '') p.selectFamilyType('Individual', true);
          if (fieldValues.Quote === '') p.updateQuote('individuals');
          break;

        case 'individuals-families':
          break;

        case 'families':
          if (fieldValues.Quote === '') p.updateQuote('families');
          break;

        case 'medicare':
          if (fieldValues.Quote === '') p.updateQuote('medicare');
          break;

        case 'essential':
          if (subroute === 'find-a-plan') {
            if (fieldValues.FamilyType === '') {
              p.selectFamilyType('Individual', true);
              RouteHelpers.history.push('/essential/find-a-plan/' +
                RouteHelpers.getStepNameFromNum(2, '', 'essential') + '?skip=true');
            }
          }
          break;

        case 'medicaid':
          if (subroute === 'find-a-plan') {
            if (fieldValues.FamilyType === '') {
              p.selectFamilyType('Individual', true);
              RouteHelpers.history.push('/medicaid/find-a-plan/' +
                RouteHelpers.getStepNameFromNum(2, '', 'medicaid') + '?skip=true');
            }
          }
          break;

        default:
          break;
      }
    }

    if (p.quiz && p.quiz.step && state.quiz.step !== p.quiz.step) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;

      return {
        'quiz': {'step': p.quiz.step}
      };
    }

    return null;
  }

  componentDidMount () {
    const p = _.clone(this.props);
    const {quiz, route} = p;
    const fapPathIdx = RouteHelpers.getPathIndexFromUrl('find-a-plan');
    const stepPathIdx = fapPathIdx ? (fapPathIdx + 1) : 0;
    const stepName = fapPathIdx ? RouteHelpers.getPathValFromIndex(stepPathIdx) : 1;
    const skipStep = window.location.search.indexOf('skip=true') > -1;
    const stepNum = RouteHelpers.getStepNumberFromRouteAndId(route, stepName);

    if (quiz.step === 1) {
      p.toggleInResults(false);

      if (!_.isNull(p.page.header.premium)) {
        p.updateHeaderPremium(null);
      }

      if (!_.isNull(p.page.header.scrollButton)) {
        p.updateHeaderScroller(null);
      }

      if (!_.isNull(p.topBanner)) {
        p.updateTopBanner(null);
      }

      if (!_.isNull(p.page.show.footer)) {
        p.updateResultsFooter(false);
      }

      if (!_.isNull(p.page.show.ratings)) {
        p.updateResultsRatings(false);
      }

      if (skipStep) {
        p.setStep(stepNum);
      }
    }
  }

  isNextStepEnabled () {
    const quizParams = quizPaths[this.props.route];
    return (this.props.quiz.step <= quizParams.steps.length);
  }

  isPrevStepEnabled () {
    return (this.props.quiz.step > 1);
  }

  nextStep () {
    if (this.isNextStepEnabled()) {
      this.updateStep(this.props.quiz.step + 1);
    }
  }

  prevStep () {
    if (this.isPrevStepEnabled()) {
      window.history.go(-1);
    }
  }

  updateStep (step) {
    // console.log(step);
    this.props.setStep(step);
    window.localStorage.setItem('lastStep', step);
    RouteHelpers.history.push(RouteHelpers.newStepIndexForUrl(step));
  }

  render () {
    const p = _.clone(this.props);
    const {
      page,
      openModal,
      closeModal,
      quiz,
      rest,
      updateQuote,
      route,
      subroute,
      routing,
      updateZip,
      countyKey,
      setFieldValue,
      changeSelectedPlan,
      updateHeaderHours,
      updateTopBanner,
      toggleInQuiz,
      toggleInResults,
      updateHeaderPremium,
      updateHeaderPhone,
      updateHeaderScroller,
      updateResultsFooter,
      updateResultsRatings
    } = p;

    let quizParams,
      stepNum,
      step,
      reducer,
      QuizView;

    quizParams = quizPaths[route];

    if (quiz.step) stepNum = quiz.step;
    else stepNum = 1;

    if (stepNum !== parseFloat(stepNum)) {
      stepNum = RouteHelpers.getStepNumberFromRouteAndId(route, stepNum);
    }

    step = quizParams.steps[stepNum - 1];
    if (_.isUndefined(step) && stepNum > quizParams.steps.length) {
      step = quizParams.steps[quizParams.steps.length - 1];
    }

    if (_.isObject(step)) {
      if (step.hasOwnProperty('reducer')) {
        reducer = p[step['reducer']];
      }
      if (step.hasOwnProperty('class')) {
        QuizView = step.class;
      }
    }

    // if (_.isObject(step) && step.hasOwnProperty('reducer')) reducer = p[step['reducer']];
    // QuizView = step.class;

    const childViewProps = _.merge({}, {
      page,
      openModal,
      closeModal,
      quiz,
      route,
      subroute,
      routing,
      reducer,
      updateQuote,
      rest,
      updateZip,
      countyKey,
      setFieldValue,
      updateHeaderHours,
      updateTopBanner,
      toggleInQuiz,
      toggleInResults,
      updateHeaderPremium,
      updateHeaderPhone,
      updateHeaderScroller,
      updateResultsFooter,
      updateResultsRatings,
      stepMethods: {
        isNextStep: this.isNextStep,
        isPrevStep: this.isPrevStep,
        nextStep: this.nextStep,
        prevStep: this.prevStep,
        setStep: this.updateStep
      },
      changeSelectedPlan
    });

    return (
      <Aux>
        {quiz.step < 2 && <Intro type={quizParams.introText} /> }
        {route !== '/quote' && <QuizView {...childViewProps} key={quiz.step} />}
      </Aux>
    );
  }
}

Quiz.propTypes = { // validate props expected
  'rest': object.isRequired,
  'route': string.isRequired,
  'quiz': object.isRequired,
  'setStep': func.isRequired,
  'fetchCounties': func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);



// WEBPACK FOOTER //
// ./src/containers/Views/Quiz.jsx